import { base64ToByteArray } from './base64TtoByteArray'

export function formatUpdateA3DocUsersJson({
    token,
    documentData,
    users
}) {
    const getFK = (customerId, code) => `${customerId}-${code.padStart(5, '0')}`;
    const attr800 = documentData.attributes.find(attr => attr.id === "800");
    const code800 = attr800 ? attr800.value.padStart(5, '0') : "";

    // Agrupar usuarios por `workplaceCode` para manejar centros únicos
    const uniqueWorkplaceCodes = Array.from(new Set(users.map(user => user.workplaceCode)));

    const documentAttributeValues = [
        {
            "ID": "1",
            "DetailsMainField": "Identificador",
            "Items": [
                {
                    "Name": "Identificador",
                    "Value": documentData.customerId
                },
                {
                    "Name": "Nombre",
                    "Value": documentData.customerName
                }
            ]
        },
        {
            // Procesa solo el atributo 800 desde documentData.attributes
            "ID": "800",
            "DetailsMainField": "Código",
            "Items": [
                { "Name": "Código", "Value": code800 },
                { "Name": "Nombre", "Value": attr800?.description || "" },
                { "Name": "Empresa", "Value": documentData.customerName },
                { "Name": "Cliente", "Value": documentData.customerName },
                { "Name": "FK", "Value": documentData.customerId }
            ]
        },
        ...uniqueWorkplaceCodes.map(workplaceCode => {
            const userForWorkplace = users.find(user => user.workplaceCode === workplaceCode);

            return {
                "ID": "801",
                "DetailsMainField": "Código",
                "Items": [
                    { "Name": "Código", "Value": workplaceCode.padStart(5, '0') },
                    { "Name": "Nombre", "Value": userForWorkplace?.workplaceName || "" },
                    { "Name": "Empresa", "Value": documentData.customerName },
                    { "Name": "Cliente", "Value": documentData.customerName },
                    { "Name": "FK", "Value": documentData.customerId }
                ]
            };
        }),
        ...users.map(user => ({
            // Atributo 802 con datos desde el usuario
            "ID": "802",
            "DetailsMainField": "Trabajador",
            "Items": [
                { "Name": "NIF", "Value": user.nif || "" },
                { "Name": "Nombre", "Value":`${user.surnames || ""}, ${user.name || ""}`.trim() || "" },
                { "Name": "Centro", "Value": user.workplaceCode.padStart(5, '0') },
                { "Name": "Empresa", "Value": documentData.customerName },
                { "Name": "FK", "Value": getFK(documentData.customerId, code800) }
            ]
        }))
    ];

    // Generar DocumentAttributes para los centros (801) y trabajadores (802) y otros atributos desde documentData excluyendo 800, 801, 802
    const documentAttributes = [
        {
            "Name": "Cliente",
            "Value": documentData.customerId,
            "ID": "1",
            "Description": documentData.customerName
        },
        {
            "Name": "Título",
            "Value": documentData.title,
            "ID": "3",
            "Description": ""
        },
        {
            // Procesa solo el atributo 800 desde documentData.attributes
            "Name": "Código",
            "Value": code800,
            "ID": "800",
            "Description": attr800?.description || ""
        },
        ...uniqueWorkplaceCodes.map(workplaceCode => {
            const userForWorkplace = users.find(user => user.workplaceCode === workplaceCode);

            return {
                "Name": "Centro",
                "Value": workplaceCode.padStart(5, '0'),
                "ID": "801",
                "Description": userForWorkplace?.workplaceName || ""
            };
        }),
        ...users.map(user => ({
            "Name": "Trabajador",
            "Value": user.nif || "",
            "ID": "802",
            "Description": `${user.surnames || ""}, ${user.name || ""}`.trim()
        })),
        ...documentData.attributes
            .filter(attr => attr.id !== "800" && attr.id !== "801" && attr.id !== "802") // Excluye 800, 801, 802
            .map(attr => ({
                "Name": attr.name,
                "Value": attr.value,
                "ID": attr.id,
                "Description": attr.description || ""
            }))
    ];

    let plantillaModificada = {
        "Token": token || null,
        "documentId": documentData.id,
        "Content": base64ToByteArray(documentData.docData) || [],
        "Extension": documentData.type || "",
        "ContainersIds": documentData.containersId || [],
        "isAppDocument": documentData.isAppDoc === 'true' ? true : false,
        ...(documentData.isAppDoc && { "ApplicationGUIDs": ['21DC83DB-B187-4993-8C3E-0B4DF8B15632'] }),
        "DocumentAttributes": documentAttributes,
        "DocumentAttributeValues": documentAttributeValues
    };

    return plantillaModificada;
}
